import { parseISO } from 'date-fns';
import { parsePhoneNumber } from 'react-phone-number-input';

export const getInitials = (
  firstName?: string | null,
  lastName?: string | null
) => {
  if (firstName && lastName) {
    return `${firstName.substring(0, 1)}${lastName.substring(0, 1)}`.toUpperCase();
  }

  if (firstName && !lastName) {
    return firstName.substring(0, 1).toUpperCase();
  }

  if (!firstName && lastName) {
    return lastName.substring(0, 1).toUpperCase();
  }

  return '??';
};

export const getDateFromUnknown = (date: unknown): Date | undefined => {
  // If the object is a date, typeof returns "object"
  if (date instanceof Date) {
    return date;
  }

  if (typeof date === 'string') {
    return parseISO(date);
  }
  return undefined;
};

export const formatPhoneNumber = (phoneNumber?: string) => {
  return phoneNumber
    ? parsePhoneNumber(phoneNumber)?.format(
        parsePhoneNumber(phoneNumber)?.country === 'US'
          ? 'NATIONAL'
          : 'INTERNATIONAL'
      )
    : undefined;
};

export const tokenizeQuery = (query: string): string[] => {
  // Convert to lowercase, remove punctuation, and split by whitespace
  return query
    .toLowerCase()
    .replace(/[^\w\s]/gi, '')
    .split(/\s+/)
    .filter((token) => token.length > 0);
};
/**
 * Sleep for a given number of milliseconds.
 * @param ms Number of milliseconds to sleep.
 * @returns Promise<void>
 */
export const sleep = (ms: number) =>
  new Promise<void>((r) => setTimeout(r, ms));
